import { Directive, HostListener, ElementRef, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDocumentNumber]',
})
export class DocumentNumberDirective {
  @Input() tipoDocIdent?: string;

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let sanitizedValue = input.value;

    // Aplicar restricciones según el tipo de documento
    if (this.tipoDocIdent) {
      switch (this.tipoDocIdent) {
        case 'Cédula de Ciudadanía':
        case 'Tarjeta de Identidad':
        case 'Permiso por Protección Temporal':
          sanitizedValue = sanitizedValue.replace(/[^0-9]/g, '');
          break;
        case 'Pasaporte':
        case 'Cédula de Extranjería':
          sanitizedValue = sanitizedValue.replace(/[^A-Za-z0-9]/g, '');
          break;
      }
    }


    const maxLength = this.getMaxLength(this.tipoDocIdent);
    if (sanitizedValue.length > maxLength) {
      sanitizedValue = sanitizedValue.slice(0, maxLength);
    }

    // Actualizar el valor del control
    this.control.control?.setValue(sanitizedValue);
    this.checkLength(sanitizedValue);
  }

  @HostListener('blur', ['$event']) onInputBlur(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.checkLength(input.value);
  }

  private checkLength(value: string): void {
    const minLength = this.getMinLength(this.tipoDocIdent);
    const maxLength = this.getMaxLength(this.tipoDocIdent);

    if (value.length < minLength || value.length > maxLength) {
      this.control.control?.setErrors({
        ...this.control.control?.errors,
        length: { minLength, maxLength }
      });
    } else {
      const errors = this.control.control?.errors;
      if (errors) {
        delete errors['length'];
        this.control.control?.setErrors(Object.keys(errors).length ? errors : null);
      }
    }
  }

  private getMinLength(tipoDocIdent?: string): number {
    switch (tipoDocIdent) {
      case 'Cédula de Ciudadanía':
        return 7;
      case 'Pasaporte':
        return 5;
      case 'Tarjeta de Identidad':
        return 7;
      case 'Cédula de Extranjería':
        return 7;
      case 'Permiso por Protección Temporal':
        return 6;
      default:
        return 1;
    }
  }

  private getMaxLength(tipoDocIdent?: string): number {
    switch (tipoDocIdent) {
      case 'Cédula de Ciudadanía':
        return 10;
      case 'Pasaporte':
        return 20;
      case 'Tarjeta de Identidad':
        return 11;
      case 'Cédula de Extranjería':
        return 15;
      case 'Permiso por Protección Temporal':
        return 15;
      default:
        return 100;
    }
  }
}
